import { BrowserRouter as Router, Route, Routes } from "react-router";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import S from "./store";

import AppWrapper from "./AppWrapper";

import ToastNotification from "./components/common/ToastNotification";
import Dashboard from "./components/dashboard";

import AnalyticsRoutes from "./components/analytics";
import PlayersRoutes from "./components/players";
import SettingsRoutes from "./components/settings";
import AppsRoutes from "./components/apps";
import AuthRoutes from "./components/auth";
import SitesRoutes from "./components/sites";
import VideosRoutes from "./components/videos";
import PaymentsRoutes from "./components/payments";
import ReportsRoutes from "./components/reports";
import BusinessRoutes from "./components/business";
import AIVideoRoutes from "./components/ai-video";

const App = () => {
  return (
    <Provider store={S.store}>
      <PersistGate loading={null} persistor={S.persistor}>
        <ToastNotification />
        <Router>
          <Routes>
            <Route path="/auth/*" element={<AuthRoutes />} />

            <Route element={<AppWrapper />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/videos/*" element={<VideosRoutes />} />
              <Route path="/ai-video/*" element={<AIVideoRoutes />} />
              {S.store.getState()?.auth?.user?.integrationType !== -1 && (
                <>
                  <Route path="/analytics/*" element={<AnalyticsRoutes />} />
                  <Route path="/business/*" element={<BusinessRoutes />} />
                  <Route path="/sites/*" element={<SitesRoutes />} />
                  <Route path="/apps/*" element={<AppsRoutes />} />
                  <Route path="/players/*" element={<PlayersRoutes />} />

                  <Route path="/settings/*" element={<SettingsRoutes />} />
                  <Route path="/payments/*" element={<PaymentsRoutes />} />
                  <Route path="/reports/*" element={<ReportsRoutes />} />
                </>
              )}
            </Route>
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
};

export default App;
